import { defineStore } from 'pinia';

import { knowledgeApiConfig } from '@/config/api/knowledge';
import { useClientApi } from '@/plugins/api/lk';
import { decorateApiActions } from '@/shared/lib';
import type { KnowledgeResponse } from '@/types/Knowledge';

export const useKnowledgeStore = defineStore('knowledge', () => {
  async function getItems (citySlug: string): Promise<KnowledgeResponse> {
    const url = knowledgeApiConfig.list;
    const { data } = await useClientApi().get<KnowledgeResponse>(url, {
      params: {
        city_of_sale: citySlug,
      },
    });

    return data;
  }

  async function getFolders (folderId: number): Promise<KnowledgeResponse> {
    const url = knowledgeApiConfig.list;
    const { data } = await useClientApi().get<KnowledgeResponse>(url, {
      params: {
        folder_id: folderId,
      },
    });

    return data;
  }

  const decoratedRethrow = decorateApiActions({
    getItems,
    getFolders,
  }, 'store/knowledge', true);

  return {
    ...decoratedRethrow,
  };
});
